import {
  ACTIVE_LOCATIONS,
  INACTIVE_LOCATIONS,
  isActiveCountry,
  LocationFullType,
  Place,
  UNITED_STATES,
} from '../../../components/Location/config';
import {
  getAutocomplePredictions,
  getCountryInfo,
  getGeocodeResults,
  getNearestPlace,
} from '../../../components/Location/helpers';
import { ReduxActionCreator } from '../../store';
import { locationSlice } from './slice';

const detectLocation: ReduxActionCreator = variables => {
  return async (dispatch, getState) => {
    fetch(
      `https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyD7xe2BVLq5j_WrSdsh4ukh9d80k68vS4M`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      }
    )
      .then(response => response.json())
      .then(async data => {
        const coordinates = data.location as { lat: number; lng: number };

        const results = await getGeocodeResults({ location: coordinates });
        const { country, state, city } = getCountryInfo(results);

        // List of possible places within country
        let places: Place[] = [];
        if (country === 'United States') {
          places = state in UNITED_STATES ? UNITED_STATES[state] : [];
        } else if (isActiveCountry(country)) {
          places = ACTIVE_LOCATIONS[country].places;
        } else if (country in INACTIVE_LOCATIONS) {
          places = INACTIVE_LOCATIONS[country];
        }

        // Find nearest place
        let placeName = '';
        if (places.length === 0) {
          placeName = country;
        } else if (places.length === 1) {
          placeName = places[0].name;
        } else {
          const { closestPlace } = getNearestPlace(places, coordinates);
          placeName = closestPlace?.name || '';
        }

        if (placeName) {
          const prediction = (
            await getAutocomplePredictions(placeName + ` ${country}`)
          )[0];

          const main = prediction.structured_formatting.main_text;
          const secondary = prediction.structured_formatting.secondary_text;
          dispatch(
            locationSlice.actions.setDetectedLocation({
              ...prediction,
              coordinates,
              country,
              state,
              city,
              inputMain: main,
              inputSecondary: secondary,
            })
          );
        }
      })
      .finally(() => dispatch(locationSlice.actions.setIsDetecting(false)));
  };
};

const selectLocation: ReduxActionCreator<LocationFullType> = variables => {
  return async (dispatch, getState) => {
    dispatch(locationSlice.actions.setSelectedLocation(variables));
  };
};

const lockLocation: ReduxActionCreator<{
  nearestActiveLocation: LocationFullType;
  nearestActiveLocationSeoLine: string;
}> = variables => {
  return async (dispatch, getState) => {
    dispatch(locationSlice.actions.setLockedLocation(variables));
  };
};

const setLastPlaceId: ReduxActionCreator<string> = variables => {
  return async (dispatch, getState) => {
    dispatch(locationSlice.actions.setLastPlaceId(variables));
  };
};

export const locationActionCreators = {
  detectLocation,
  selectLocation,
  lockLocation,
  setLastPlaceId,
};
